import React from "react";
import { Link, withRouter } from "react-router-dom";

const Columns = (addUpd) => {
  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      id: "rutas",
      name: "Rutas",
      selector: (row) => row.rutas,
      sortable: true,
      wrap: true,
    },
    {
      id: "reseller_name",
      name: "Nombre reseller",
      selector: (row) => row?.reseller?.name,
      sortable: true,
      wrap: true,
    },
    {
      id: "reseller_emial",
      name: "Correo reseller",
      selector: (row) => row?.reseller?.email,
      sortable: true,
      wrap: true,
    },
    {
      id: "actions",
      name: "Acciones",
      width: "10%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar usuario"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];
  return columns;
};

export default Columns;
